import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'errorPage.loggedOut.title' }),
    description: translate({ id: 'errorPage.loggedOut.description' }),
    primaryAction: translate({ id: 'errorPage.loggedOut.primaryAction' }),
  }))

  return api
}
